import React from 'react';
import styled from 'styled-components';
import DocumentsContent from 'components/renter_application/natural_person/DocumentsContentComponent';
import EarningsContent from 'components/renter_application/natural_person/EarningsContentComponent';
import ProfileContent from 'components/renter_application/natural_person/ProfileContentComponent';
import ReferencesContent from 'components/renter_application/natural_person/ReferencesContentComponent';
import PaymentContent from 'components/renter_application/PaymentContentComponent';
import HomeApplication from 'models/HomeApplication';
import { NATURAL_PERSON } from 'utils/Constants';
import { StepperContent } from 'styles/Steppers';

const ProfileStepper = styled(StepperContent)`
  padding: 0;
`;

type PropsType = {
  homeApplication: HomeApplication,
  langSelected: string,
  typePersonSelected: number,
  visibleFormBill: boolean,
  onHomeApplicationChange: () => void,
  onHomeApplicationCancel: () => void,
  isTheStepVisible: (number, number | null, boolean | null) => boolean,
  onNextStep: () => void,
  onPrevStep: () => void,
  prevStepText: string,
  appType: string,
  isOnlyEditIncome: boolean
};

class NaturalPersonHomeApplication extends React.Component<PropsType, {}> {
  render() {
    const {
      homeApplication,
      langSelected,
      typePersonSelected,
      visibleFormBill,
      onHomeApplicationChange,
      onHomeApplicationCancel,
      isTheStepVisible,
      onNextStep,
      onPrevStep,
      prevStepText,
      appType,
      isOnlyEditIncome
    } = this.props;
    return (
      <div>
        {isTheStepVisible(1, NATURAL_PERSON) && (
          <ProfileStepper>
            <ProfileContent
              homeApplication={homeApplication}
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              onPrevStep={onPrevStep}
            />
          </ProfileStepper>
        )}
        {isTheStepVisible(2, NATURAL_PERSON) && (
          <StepperContent>
            <EarningsContent
              homeApplication={homeApplication}
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              onPrevStep={onPrevStep}
              isOnlyEditIncome={isOnlyEditIncome}
            />
          </StepperContent>
        )}
        {isTheStepVisible(3, NATURAL_PERSON) && (
          <StepperContent>
            <ReferencesContent
              homeApplication={homeApplication}
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              onPrevStep={onPrevStep}
            />
          </StepperContent>
        )}
        {isTheStepVisible(4, NATURAL_PERSON) && (
          <StepperContent>
            <DocumentsContent
              homeApplication={homeApplication}
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              onPrevStep={onPrevStep}
              appType={appType}
            />
          </StepperContent>
        )}
        {isTheStepVisible(5, NATURAL_PERSON) && (
          <StepperContent>
            <PaymentContent
              onChange={onHomeApplicationChange}
              onCancel={onHomeApplicationCancel}
              langSelected={langSelected}
              typePersonSelected={typePersonSelected}
              nextAction={onNextStep}
              visibleFormBill={visibleFormBill}
              onPrevStep={onPrevStep}
              homeAppData={homeApplication}
              prevStepText={prevStepText}
            />
          </StepperContent>
        )}
      </div>
    );
  }
}
export default NaturalPersonHomeApplication;
